"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
var react_1 = __importDefault(require("react"));
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var useStyles = (0, system_1.makeStyles)(function (theme) { return ({
    tooltip: function (_a) {
        var invert = _a.invert;
        return (__assign(__assign(__assign({ borderRadius: 16, padding: '8px 16px', backgroundColor: invert
                ? theme.go.schemes.colors.system.BgInvert
                : theme.go.schemes.colors.system.BgMain, minHeight: 40, display: 'flex', alignItems: 'center', whiteSpace: 'pre-wrap' }, theme.go.mixins.typography.createStyles({
            typographyVariant: system_1.BGTypographyVariants.Caption1,
            typographyGroup: 'tight',
            typographyWeight: 'regular',
        })), ((0, utils_1.isIE11)()
            ? theme.go.mixins.effects.ShadowBottom
            : theme.go.mixins.effects.TooltipShadow)), { color: invert
                ? theme.go.schemes.colors.system.TextInvert
                : theme.go.schemes.colors.system.TextMain }));
    },
    tooltipPlacementBottom: {},
    tooltipPlacementLeft: {},
    tooltipPlacementRight: {},
    tooltipPlacementTop: {},
    arrow: {
        background: function (_a) {
            var invert = _a.invert;
            return invert
                ? "url(".concat(theme.go.schemes.components.tooltips.invertArrowPath, ")")
                : "url(".concat(theme.go.schemes.components.tooltips.arrowPath, ")");
        },
        width: '18px !important',
        height: '9px !important',
        '$tooltipPlacementBottom &': {
            transform: 'rotate(180deg)',
            marginLeft: '16px !important',
            marginRight: '16px !important',
        },
        '$tooltipPlacementTop &': {
            marginLeft: '16px !important',
            marginRight: '16px !important',
        },
        '$tooltipPlacementLeft &': {
            flip: false,
            right: '-4px !important',
            transform: 'rotate(-90deg)',
            marginTop: '12px !important',
            marginBottom: '12px !important',
        },
        '$tooltipPlacementRight &': {
            flip: false,
            left: '-4px !important',
            transform: 'rotate(90deg)',
            marginTop: '12px !important',
            marginBottom: '12px !important',
        },
        '&::before': {
            content: 'none',
        },
    },
}); });
function Tooltip(_a) {
    var invert = _a.invert, classes = _a.classes, props = __rest(_a, ["invert", "classes"]);
    var styleClasses = useStyles({ invert: invert });
    return (react_1.default.createElement(Tooltip_1.default, __assign({ arrow: true, classes: __assign(__assign({}, styleClasses), { tooltip: (0, utils_1.cn)(classes === null || classes === void 0 ? void 0 : classes.tooltip, styleClasses.tooltip), popper: classes === null || classes === void 0 ? void 0 : classes.popper, tooltipPlacementBottom: (0, utils_1.cn)(classes === null || classes === void 0 ? void 0 : classes.tooltipPlacementBottom, styleClasses.tooltipPlacementBottom), tooltipPlacementLeft: (0, utils_1.cn)(classes === null || classes === void 0 ? void 0 : classes.tooltipPlacementLeft, styleClasses.tooltipPlacementLeft), tooltipPlacementRight: (0, utils_1.cn)(classes === null || classes === void 0 ? void 0 : classes.tooltipPlacementRight, styleClasses.tooltipPlacementRight), arrow: (0, utils_1.cn)(classes === null || classes === void 0 ? void 0 : classes.arrow, styleClasses.arrow) }) }, props)));
}
exports.Tooltip = Tooltip;
